import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Loader from '~/component/common/Loader';
import auth0Client from '~/Auth/AuthClient';

class CallbackPage extends Component {
  async componentDidMount() {
    await auth0Client.handleAuthentication();
    this.props.history.replace('/');
  }

  render() {
    return (
      <Loader />
    );
  }
}

export default withRouter(CallbackPage);